import axios from 'axios';
export async function sendMagicLink(payload) {
    return await axios.post('/api/auth/model_login', payload)
}